/*eslint-disable no-undef*/
import http from './http';

function getPostTypes() {
  const restAPIURL = restURL + 'google-books-importer/v1/posttypes';
  return http.get(restAPIURL, {
    headers: { 'X-WP-Nonce': restNonce }
  });
}

function getCustomMeta() {
  const restAPIURL = restURL + 'google-books-importer/v1/customfields';
  return http.get(restAPIURL, {
    headers: { 'X-WP-Nonce': restNonce }
  });
}

function getOptions() {
  const restAPIURL = restURL + 'google-books-importer/v1/options';
  return http.get(restAPIURL, {
    headers: { 'X-WP-Nonce': restNonce }
  });
}

function updateOption(data) {
  const restAPIURL = restURL + 'google-books-importer/v1/options';
  return http.post(
    restAPIURL,
    {
      option_name: 'gbi_fields',
      option_value: data
    },
    {
      headers: { 'X-WP-Nonce': restNonce }
    }
  );
}

function updateAPIKey(key) {
  const restAPIURL = restURL + 'google-books-importer/v1/options';
  return http.post(
    restAPIURL,
    {
      option_name: 'gbi_apikey',
      option_value: key
    },
    {
      headers: { 'X-WP-Nonce': restNonce }
    }
  );
}

export { getPostTypes, getCustomMeta, getOptions, updateOption, updateAPIKey };



// WEBPACK FOOTER //
// ./src/services/options.js